module.exports = __webpack_public_path__ + "assets/105048aa75694a2af519dda70a646cda.svg";


//////////////////
// WEBPACK FOOTER
// ./webpack/assets/spotify_icon_green.svg
// module id = 3659
// module chunks = 0